
import { mapActions } from 'vuex';
import fileUploadService from '~/services/fileUpload';
import flytippingMixin from '~/mixins/flytipping';
import loginUserMixin from '~/mixins/loginUser';
import registerUserMixin from '~/mixins/registerUser';
import { reportStorage } from '~/services/savedReports';
import FlytippingDetailsForm from '~/components/flytipping/form/FlytippingDetailsForm.vue';
import UserForm from '~/components/user/UserForm.vue';

export default {
    name: 'FlyTippingReport',
    mixins: [loginUserMixin, registerUserMixin, flytippingMixin],
    data() {
        return {
            anonymous: 1,
            description: '',
            existingMedia: [],
            images: [],
            latitude: '',
            latLng: '',
            locationObject: {},
            online: typeof window !== 'undefined' ? window.navigator.onLine : true,
            road: '',
            savedReports: [],
            showUserStep: !this.$store.state.auth.loggedIn,
            land_type: 0,
            what3words: '',
        };
    },
    head() {
        return {
            title: `${this.$t('metadata.flytipping-report.title')} - ClearWaste.com`,
            meta: [
                { hid: 'description', name: 'description', content: this.$t('metadata.flytipping-report.description') },
                { hid: 'og:title', property: 'og:title', content: this.$t('metadata.flytipping-report.title') },
                { hid: 'og:description', property: 'og:description', content: this.$t('metadata.flytipping-report.description') },
                { hid: 'og:url', proprty: 'og:url', content: `${this.$config.domain}${this.$route.path}` },
            ],
        };
    },
    computed: {
        steps() {
            const steps = [
                {
                    name: 'report',
                    title: this.$t('flytipping.form.explanation'),
                    component: FlytippingDetailsForm,
                    props: {
                        online: this.online,
                        savedReports: this.savedReports,
                    },
                },
            ];

            if (this.showUserStep && this.online) {
                steps.push({
                    name: 'user',
                    component: UserForm,
                    props: {
                        buttonText: this.$t('flytipping.report'),
                        disableRedirect: true,
                    },
                });
            }
            return steps;
        },
    },
    created() {
        this.$form.addValidations({
            ...this.getUserLoginValidations(),
            ...this.getUserValidations(),
        });
    },
    mounted() {
        this.$nextTick(async () => {
            this.savedReports = await reportStorage.get();
        });
    },
    methods: {
        ...mapActions(['setFlashMessage']),
        uploadImages() {
            const imagePromises = this.images.map((image) => image.promise);
            return new Promise((resolve) => {
                Promise.all(imagePromises).then((images) => {
                    if (!images[0]) {
                        resolve([]);
                    }
                    // Images have already been processed
                    if (images[0].id) {
                        resolve(images.map((image) => image.id));
                        return;
                    }
                    fileUploadService(images, this.$axios, this.$config, this.$sentry).then((data) => {
                        if (!data.length || !data[0]?.id) {
                            resolve('There was an error submitting your report please try again.');
                            return;
                        }
                        resolve(data.map((image) => image.id));
                    });
                });
            });
        },
        createReport() {
            if (!this.online) {
                this.saveReport();
                return;
            }
            this.$form.$submitted = true;
            this.$form.replaceValidations({ latLng: [], what3words: [] });
            if (this.$form.validate()) {
                this.$clearwaste.$loading.start();
                this.$form.$submitting = true;
                this.uploadImages().then((images) => {
                    if (typeof images === 'string') {
                        this.setFlashMessage({
                            message: images,
                            type: 'error',
                        });
                        this.$clearwaste.$loading.finish();
                        this.$form.$submitting = false;
                        return;
                    }
                    this.$form
                        .submit(this.$config.endpoints.report, '$post', {
                            anonymous: this.anonymous,
                            description: this.description,
                            private_land: this.land_type,
                            images,
                            ...this.locationObject,
                        })
                        .then(({ message, report }) => {
                            this.$router.push({ name: 'flytipping-report-id', params: { id: report.id }, query: { thanks: true } });
                            this.setFlashMessage({
                                message,
                            });
                        });
                });
            }
        },
        geocomplete(location) {
            this.locationObject = location;
        },
        saveReport() {
            reportStorage.save({
                anonymous: this.anonymous,
                description: this.description,
                images: this.images,
                latLng: this.latLng,
                private_land: this.land_type,
                what3words: this.what3words,
            });
            this.$router.push({ name: 'flytipping' });
            this.setFlashMessage({
                message: this.$t('flytipping.report_saved'),
            });
        },
    },
};
